<template>
  <div class="login-container">
    <div class="login-card shadow">
      <h2 class="text-center mb-4 text-body-emphasis fw-bold">CTech - ERP Comex</h2>

      <form @submit.prevent="handleLogin">
        <div v-if="erroLogin" class="alert alert-danger border-0 shadow-sm">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ erroLogin }}
        </div>

        <div v-if="mostrarSessaoExpirada" class="alert alert-warning border-0 shadow-sm">
          <i class="bi bi-clock-history me-2"></i> Sua sessão expirou por inatividade. Faça login novamente.
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" v-model="email" required placeholder="seu@email.com">
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Senha</label>
          <div class="input-group">
            <input :type="showSenha ? 'text' : 'password'" class="form-control" id="password" name="current-password" autocomplete="current-password" v-model="senha" required placeholder="••••••••">
            <button class="btn btn-outline-secondary" type="button" @click="showSenha = !showSenha" tabindex="-1" :title="showSenha ? 'Ocultar senha' : 'Mostrar senha'">
              <i :class="['bi', showSenha ? 'bi-eye-slash' : 'bi-eye']"></i>
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end mb-4">
          <router-link to="/recuperar-senha" class="form-text text-decoration-none">Esqueceu a senha?</router-link>
        </div>

        <div class="d-grid">
          <button type="submit" class="btn btn-primary btn-lg" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Entrar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

defineOptions({
  name: 'TelaLogin'
})

const route = useRoute()
const authStore = useAuthStore()

const email = ref('')
const senha = ref('')
const showSenha = ref(false)
const erroLogin = ref(null)
const mostrarSessaoExpirada = ref(false)
const isLoading = ref(false)

onMounted(() => {
  if (route.query.sessaoExpirada === 'true') {
    mostrarSessaoExpirada.value = true
  }
})

const handleLogin = async () => {
  isLoading.value = true
  erroLogin.value = null

  const sucesso = await authStore.login(email.value, senha.value)

  if (sucesso) {
    // Força reload completo para carregar o Dashboard com estado limpo
    // Evita tela fantasma com dados de sessão anterior
    window.location.href = '/'
  } else {
    erroLogin.value = 'Email ou senha inválidos. Tente novamente.'
  }

  isLoading.value = false
}
</script>

<style scoped>
/* GUARDIÃO: Variáveis CSS do Bootstrap 5 para suportar Dark Mode automaticamente */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--bs-tertiary-bg);
  transition: background-color 0.3s ease;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 2.5rem;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>
